import React from 'react';

const EventDetailsSkeleton = () => (
  <div className="max-w-6xl mx-auto px-4 py-8 w-full animate-pulse" aria-busy="true" aria-label="Loading event details">
    <div className="aspect-[21/9] bg-gray-200 rounded-xl mb-8" />
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      <div className="lg:col-span-2 space-y-6">
        <div className="h-8 bg-gray-200 rounded w-3/4" />
        <div className="h-4 bg-gray-200 rounded w-1/2" />
        <div className="space-y-3 pt-4">
          <div className="h-4 bg-gray-200 rounded w-full" />
          <div className="h-4 bg-gray-200 rounded w-full" />
          <div className="h-4 bg-gray-200 rounded w-5/6" />
        </div>
        <div className="h-40 bg-gray-200 rounded-lg" />
      </div>
      <div className="space-y-4">
        <div className="bg-white rounded-xl border border-gray-100 p-6 space-y-4">
          <div className="h-5 bg-gray-200 rounded w-2/3" />
          <div className="h-10 bg-gray-200 rounded-lg" />
          <div className="h-12 bg-gray-200 rounded-lg" />
        </div>
      </div>
    </div>
  </div>
);

export default EventDetailsSkeleton;
